// extracted by css-extract-rspack-plugin
var _1 = "error__rd9JL";
var _2 = "error__highlight__Nr7y2";
var _3 = "label__Gvd3f";
var _4 = "label__name__eivap";
var _5 = "label__required__MPAK0";
var _6 = "required__oFP9p";
export { _1 as "error", _2 as "error__highlight", _3 as "label", _4 as "label__name", _5 as "label__required", _6 as "required" }
export default { "error": _1, "error__highlight": _2, "label": _3, "label__name": _4, "label__required": _5, "required": _6 }
